/* eslint-disable no-prototype-builtins */
/* eslint-disable camelcase */
import Cookies from "js-cookie"
import { Message, Loading } from "element-ui"
import Vue from "vue"
import { Base64 } from "js-base64"
import { getAid } from "../plugins/env"
import { getLanguage, translate } from "@/plugins/i18n"
import { getLang, getIsOnline, getCommonParam } from "@/plugins/env"
import { getStoreInfo, getComm } from "@/api/comm"
import storage from "@/utils/storage"

export function reSetLogin() {
  const arr = ["isOnline", "token", "store", "latitude", "longitude", "pickUpStoreId", "shipmentType"]
  arr.forEach(item => {
    removeCookies(item)
  })
  const userInfo = [
    "commData",
    "accountInfo",
    "storeInfo",
    "hadShowDefaultAddress",
    "curSelAddress",
    "pickUpStoreId",
    "deliveryMethod",
    "curSelStore"
  ]
  userInfo.forEach(item => {
    localStorage.removeItem(item)
  })
}
export function resetLocal() {
  const userInfo = ["commData", "accountInfo", "storeInfo", "hadShowDefaultAddress", "curSelAddress"]
  userInfo.forEach(item => {
    localStorage.removeItem(item)
  })
}
/**
 * @description: 弹出登录、注册 popUp
 * @param type {string}
 * @return {*}
 * @author:
 */
const flag = true
const loadingInstance = null
// TODO 网站域名适配
export function openPop(fromPath = "") {
  if (process.server) {
    return
  }
  const lang = getLanguage()
  let openUrl = ""
  let redirect_url = ""
  const target_url = fromPath || window.location.href
  let sinup_url_en = ""
  let sinup_url_zh = ""
  const domain = getSubdomain()
  const commonParams = getCommonParam()
  const baseUrl = domainAdaptationFullURL()
  if (process.env.NODE_ENV === "production") {
    redirect_url = `${baseUrl}/api/login/callback`
    sinup_url_en = " https://www.yuurewards.com/en/super/login-info"
    sinup_url_zh = " https://www.yuurewards.com/zh-hant/super/login-info"
  } else if (process.env.NODE_ENV === "uat") {
    redirect_url = `${baseUrl}/api/login/callback`
    sinup_url_en = "https://sit.newco.com.hk/en/super/login-info"
    sinup_url_zh = "https://sit.newco.com.hk/zh-hant/super/login-info"
  } else if (process.env.NODE_ENV === "test") {
    redirect_url = `${baseUrl}/api/login/callback`
    sinup_url_en = "https://sit.newco.com.hk/en/super/login-info"
    sinup_url_zh = "https://sit.newco.com.hk/zh-hant/super/login-info"
  } else if (process.env.NODE_ENV === "development") {
    redirect_url = `${baseUrl}/api/login/callback`
    sinup_url_en = "https://sit.newco.com.hk/en/super/login-info"
    sinup_url_zh = "https://sit.newco.com.hk/zh-hant/super/login-info"
  }
  const venderId = commonParams.venderId
  const target_url_encode = encodeURIComponent(target_url)
  if (lang == "en_US") {
    openUrl = `${sinup_url_en}?callbackUrl=${redirect_url}?target_url=${target_url_encode}&domain=${domain}&venderId=${venderId}`
  } else if (lang == "zh_HK") {
    openUrl = `${sinup_url_zh}?callbackUrl=${redirect_url}?target_url=${target_url_encode}&domain=${domain}&venderId=${venderId}`
  }
  reSetLogin()
  window.location.href = openUrl
}

/**
 * @description: 获取登录态  true：已登录 false：过期/未登录
 * @param {*}
 * @return {*}
 * @author:
 */
export function getLoginStatus() {
  return {
    isOnline: getIsOnline()
  }
}

/**
 * @description: 获取当前 URL 一级域名 ,如果是 IP 地址 或者localhost，则直接返回, 顶级域名前一级是一级域名
 * @param {*}
 * @return {*}
 * @author:
 */
export function getSubdomain() {
  if (document.domain.includes("rta-os")) return document.domain
  try {
    let subdomain = ""
    const topDomain = [
      "com",
      "net",
      "org",
      "edu",
      "gov",
      "info",
      "biz",
      "name",
      "aero",
      "info",
      "mil",
      "pro",
      "cn",
      "hk",
      "tw"
    ]
    const { domain } = document
    // 若为 IP 地址、localhost，则直接返回
    const ipAddressReg =
      /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
    if (ipAddressReg.test(domain) || domain === "localhost") {
      return domain
    }
    const domainList = domain.split(".")
    let index = domainList.length - 1
    topDomain.forEach(item => {
      if (domain.includes(item)) {
        const i = domainList.findIndex(d => d == item)
        if (i != -1 && i <= index) {
          index = i
        }
      }
    })
    const len = index - 1 < 0 ? 0 : index - 1
    subdomain = domainList.slice(len).join(".")
    return subdomain || document.domain
  } catch (e) {
    return document.domain
  }
}

/**
 * @description: 设置cookies
 * @param {*} key
 * @param {*} value
 * @return {*}
 * @author:
 */
export function setCookies(key, value, op = {}) {
  console.log(`setCookies ${key} = `, value)
  const options = Object.assign({}, { domain: getSubdomain(), Secure: true }, op)
  // console.log("setCookies options:", options)
  Cookies.set(key, value, options)
}
/**
 * @description: 设置cookies
 * @param {*} key
 * @return {*}
 * @author:
 */
export function removeCookies(key) {
  // console.log(`removeCookies ${key}`)
  // console.log("domain", getSubdomain())
  Cookies.remove(key, { domain: getSubdomain() })
}

export class Deferred {
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }
}
export const frameworkStartedDefer = new Deferred()

export const transformCateDataToCascaderData = function (list) {
  if (!list) return null
  const result = []
  for (let i = 0; i < list.length; i++) {
    result.push({
      name: list[i].categoryName,
      id: list[i].categoryId,
      child: transformCateDataToCascaderData(list[i].childCategoryList)
    })
  }
  return result
}

export const priceFormat = function (num) {
  if (isNaN(num)) return ""
  num = Number(num)
  return (num / 100).toFixed(2).toString().split(".")
}

export const priceFormatOther = function (num) {
  if (isNaN(num)) return ""
  num = Number(num)
  return (num / 100).toFixed(2)
}

export const findPath = function (tree, id, result = []) {
  if (!tree || !id) return []
  for (let i = 0; i < tree.length; i++) {
    const item = tree[i]
    if (item.id == id) {
      result.push({ id: item.id, name: item.name })
      return result
    }
    if (item.child) {
      result.push({ id: item.id, name: item.name })
      const res = findPath(item.child, id, result)
      if (res) {
        return result
      }
      result.pop()
    }
  }
  return false
}

// 獲取已選中加購數量
export const getCartCheckedCount = function (storeGroup) {
  let num = 0
  storeGroup.forEach(v => {
    num += Number(v.checkedCountWithoutGift)
  })
  return num
}

// 全局global message notice
export const showGlobalMessage = function ({ message, subMessage, gap, iconClass }) {
  const subMessageHtml = subMessage ? `<span class="global-message-notice-text-minor">${subMessage}</span>` : ""

  const messageHtml = `<div class="global-message-notice-box">
    <svg class="${iconClass}" aria-hidden="true">
      <use xlink:href="#icon-${iconClass}"></use>
    </svg>
    <div class="global-message-notice-content">
      <span class="global-message-notice-text">${message}</span>
      ${subMessageHtml}
    </div>
  </div>`
  Message({
    type: "info",
    iconClass: "",
    customClass: "global-message-notice",
    offset: gap,
    duration: 5000,
    dangerouslyUseHTMLString: true,
    message: messageHtml
  })
}

// 格式化地址列表到address sdk
export const formateAddress = function (address) {
  let addressArr = []
  addressArr = address.map(item => {
    return {
      Type: item.type,
      Address1: `{'UnitFloor':'${item.unitFloor}','BuildingEstate':'${item.buildingEstate || ""}'}`,
      Address2: item.address2,
      City: item.city || "",
      State: `{'Priority': '${item.priority}', 'Label':'${item.label}'}`,
      PostalCode: `{'lat': '${item.lat}', 'lng': '${item.lng}', 'GPlaceId': '${item.gplaceId}'}`,
      Region: item.region,
      Country: item.country || "",

      address2: item.address2,
      consignee: item.consignee,
      gplaceId: item.gplaceId,
      label: item.label,
      lat: item.lat,
      lng: item.lng,
      mobilPhone: item.mobilPhone,
      priority: item.priority,
      region: item.region,
      type: item.type,
      unitFloor: item.unitFloor,
      webuserId: item.webuserId
    }
  })
  return addressArr
}
// address sdk 地址格式化回原格式
export const reformateAddress = function (address) {
  const addressObj = {
    address2: address.address2,
    consignee: address.consignee,
    gplaceId: address.gplaceId,
    label: address.label,
    lat: address.lat,
    lng: address.lng,
    mobilPhone: address.mobilPhone,
    priority: address.priority,
    region: address.region,
    type: address.type,
    unitFloor: address.unitFloor,
    webuserId: address.webuserId
  }

  return addressObj
}
export const formateLang = function (lang) {
  if (lang == "zh_HK") {
    lang = "zh_hant"
  } else if (lang == "en_US") {
    lang = "en"
  }
  return lang
}

// only for client
export const resetStoreInfo = async function (curSelAddress) {
  try {
    const param = {
      longitude: curSelAddress.lng,
      latitude: curSelAddress.lat,
      shipmentType: 1,
      aid: curSelAddress.id
    }
    await getStoreInfo({ param })

    window.location.reload()
  } catch (error) {
    console.log("获取storinfo 失败", error)
  }
}

// 当前active的地址
export const isAddressActive = function (item = {}, compareItem = {}) {
  const { type } = item
  const { type: compareType } = compareItem
  if (type && compareType && type === compareType) {
    return true
  }
  return false
}

// 购物车/结算页动态计算tooltip宽度
export const tooltipCustomStyle = async function (index) {
  await Vue.nextTick()
  const titleEl = document.getElementById(`custom-item-title${index}`)
  const titleWidth = (titleEl && titleEl.clientWidth) || 0
  const iconEl = document.getElementById(`custom-item-icon${index}`)
  const iconWidth = (iconEl && iconEl.clientWidth) || 0
  const wrapperWidth = 380
  const left = 21
  return { width: `${(wrapperWidth - titleWidth + iconWidth + left) / 100}rem` }
}

export function subStringMulti(text, begin, end) {
  let regex
  if (end == "\\n") {
    regex = new RegExp(begin + "(.+)", "g")
  } else {
    regex = new RegExp(begin + "([\\s\\S]+?)" + end, "g")
  }
  try {
    let result
    const blocks = []
    while ((result = regex.exec(text)) != null) {
      blocks.push(result[1].trim())
    }
    return blocks
  } catch (err) {
    return null
  }
}

export function getDshopUrlPath(dshopUrl) {
  const result = subStringMulti(dshopUrl, "/act/", ".html")
  return result && result.length ? result[0] : ""
}
export function noAddressCheck() {
  const { isOnline } = getLoginStatus()
  if (isOnline) {
    const deliveryMethod = getDeliveryMethod()

    if (deliveryMethod === "homeDelivery") {
      // 配送模式
      const accountInfo = storage.get("accountInfo", { useBase64: true })
      if (!accountInfo.address || accountInfo.address?.length === 0) {
        return true
      }
    } else if (deliveryMethod === "clickCollect") {
      // 自提模式
      const curSelStore = localStorage.getItem("curSelStore") ? JSON.parse(localStorage.getItem("curSelStore")) : null
      // 门店不存在 || 无erpStoreId(自提门店)字段
      if (!curSelStore || !("erpStoreId" in curSelStore)) {
        return true
      }
    }
  }
  return false
}
export function openNoAddressPop() {
  Vue.$messageBox
    .open({
      title: translate("common.noAddressPopTitle"),
      message: translate("common.noAddressPopContent"),
      cancelText: translate("common.backToBrowse"),
      confirmText: translate("common.addNewAdd")
    })
    .then(() => {
      Vue.$deliveryMethod.open({ deliveryMethodValue: getDeliveryMethod() })
    })
    .catch(res => {
      console.log(res)
    })
}

// 检测浏览器是否支持WebP格式，并缓存结果
const isWebPSupported = (function () {
  let result = null
  return function () {
    if (!process.client) {
      return true
    }
    if (result === null) {
      const canvas = document.createElement("canvas")
      result = canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0
    }
    return result
  }
})()

const imgMap = {}
let imgIndex = -1
const imgPrefixs = ["", "1", "2"]
function getRandomImgPrefix() {
  imgIndex++
  return imgPrefixs[imgIndex % imgPrefixs.length]
}

/**
 * 格式化图片url 【动态设置size】
 * @param {*} url
 * @param {*} config
 * @returns
 */
export function formatImgUrl(url, config) {
  const { width, height } = config || {}
  const regex = /(\.rtacdn-os\.com)/ // 匹配"//img.rtacdn-os.com"
  if (!url.includes(".webp")) {
    if (width && height) {
      url = url.replace("_240x240H", "")
      url = `${url}_${width}x${height}H`
      if (isWebPSupported()) {
        url = `${url}.webp`
      }
    } else if (isWebPSupported()) {
      url = `${url}_.webp`
    }
  }
  if (imgMap[url]) {
    return imgMap[url]
  }
  const prefix = getRandomImgPrefix()
  return (imgMap[url] = url.replace(regex, prefix + "$1"))
}

/**
 * 格式化商品图片
 * @param {*} url
 * @param {*} config
 * @returns
 */
export function formatWareImgUrl(url, config = { width: 360, height: 360 }) {
  const sizeRegex = /_(\d+)x(\d+)H/
  const matchSize = url.match(sizeRegex)
  if (!url.includes(".webp") && !/_240x240H/.test(url) && matchSize) {
    url = url.replace(sizeRegex, "")
    config = { width: matchSize[1], height: matchSize[2] }
  }
  return formatImgUrl(url, config)
}

export const getDisplayAddress = item => {
  if (!item) {
    return ""
  }
  return item.address
}

export const isCartPage = () => {
  if (process.client) {
    return (window.location.href || "").includes("/cart")
  }
  return false
}

export function parseJSON(data) {
  if (typeof data === "string") {
    try {
      data = JSON.parse(data)
    } catch (error) {
      console.log("JSON解析异常", error)
    }
  }
  return data
}

export function isPlainObject(obj) {
  if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
    return false
  }
  return Object.prototype.toString.call(obj) === "[object Object]"
}

// 判断是否是函数
export function isFunction(value) {
  return typeof value === "function"
}

export const clearBeforeSet = function () {
  const arr = ["latitude", "longitude", "store"]
  arr.forEach(item => {
    removeCookies(item)
  })
  const userInfo = ["storeInfo", "hadShowDefaultAddress", "curSelAddress", "accountInfo"]
  userInfo.forEach(item => {
    localStorage.removeItem(item)
  })
}

export function joinCookie(existingCookie, newCookieObject = {}) {
  const existingCookieObj = existingCookie
    ? existingCookie
        .split(";")
        .map(cookie => cookie.trim().split("="))
        .reduce((acc, [key, value]) => {
          acc[key] = value
          return acc
        }, {})
    : {}

  const mergedCookieObj = { ...existingCookieObj, ...newCookieObject }

  const mergedCookieString = Object.entries(mergedCookieObj)
    .map(([key, value]) => `${key}=${value}`)
    .join("; ")

  return mergedCookieString
}

// 从对象中选择指定的键，创建并返回一个新对象
function pick(obj, keys) {
  const result = {}
  keys.forEach(key => {
    if (obj.hasOwnProperty(key) && obj[key]) {
      result[key] = obj[key]
    }
  })
  return result
}

export function getRequestHeaders({ req, store }) {
  const headers = {}
  if (req && req.headers) {
    const lang = getLang()
    const { resCookies } = store.state
    headers.cookie = joinCookie(
      req.headers.cookie || "",
      pick({ "superweb-locale": lang, ...resCookies }, ["superweb-locale", "store", "longitude", "latitude"])
    )
    if (req.headers["denv-uat"]) {
      headers["denv-uat"] = req.headers["denv-uat"]
    }
    if (req.headers["denv-test"]) {
      headers["denv-test"] = req.headers["denv-test"]
    }
    // header 透传区分网站类型
    if (req.headers["domain-flag"]) {
      headers["domain-flag"] = req.headers["domain-flag"]
    }
    // 透传x-forwarded-host
    if (req.headers["x-forwarded-host"] || req.headers.host) {
      headers["x-forwarded-host"] = req.headers["x-forwarded-host"] || req.headers.host.split(":")[0]
    }
  }
  return headers
}

export function getStockMax(stock) {
  const MAX_VALUE = 99
  if (!stock) {
    return MAX_VALUE
  }
  if (stock > MAX_VALUE) {
    return MAX_VALUE
  }
  return stock
}

export function getDeliveryMethod() {
  const { shipmentType } = getCommonParam()

  return shipmentType == 2 ? "clickCollect" : "homeDelivery"
}

export const getCurrentAddress = () => {
  const { isOnline } = getLoginStatus()
  const accountInfo = localStorage.getItem("accountInfo") ? base64Decode(localStorage.getItem("accountInfo")) : ""
  const aid = getAid()
  let curSelAddress = ""
  if (!isOnline) {
    return ""
  } else if (aid) {
    // 已登录，且选择过地址
    if (accountInfo) {
      const curSel = accountInfo.address && accountInfo.address.find(item => item.id == aid)
      curSelAddress = curSel || ""
    }
    // todo 已选择的不在地址列表中 删除已选择？
    return curSelAddress
  } else {
    // 已登录，未选择过地址,有 default 则返回default, 没有返回address 第一条（最近添加的地址）
    if (accountInfo) {
      const latestAddress = (accountInfo.address && accountInfo.address[0]) || ""
      const defaultAddressArr = accountInfo.address && accountInfo.address.find(item => item.priority == "Default")
      const defaultAddress = defaultAddressArr || ""
      return defaultAddress || latestAddress
    } else {
      return ""
    }
  }
}

export const parseNumber = (input, defaultValue) => {
  // 尝试将输入转换为数值
  const numberValue = parseFloat(input)

  // 检查是否成功转换
  if (!isNaN(numberValue)) {
    return numberValue
  } else {
    return defaultValue !== undefined ? defaultValue : 0
  }
}
export function base64Decode(data) {
  if (!data) {
    return ""
  } else {
    try {
      return JSON.parse(Base64.decode(data))
    } catch (error) {
      return JSON.parse(data)
    }
  }
}

/**
 * 创建定时任务器
 * @param {*} config
 * @returns
 */
export const createScheduleTask = config => {
  const { callback, interval, immediate } = config
  let timeoutId
  let running = false

  function execute() {
    callback()
    timeoutId = setTimeout(execute, interval)
  }

  function start() {
    if (!running) {
      running = true
      if (immediate) {
        // 立即执行
        execute()
      } else {
        // 延迟执行第一次
        timeoutId = setTimeout(execute, interval)
      }
    }
  }

  function stop() {
    clearTimeout(timeoutId)
    running = false
  }

  function isRunning() {
    return running
  }

  return {
    start,
    stop,
    isRunning
  }
}

export function domainAdaptationURL() {
  let baseURL = ""
  if (process.server) {
    baseURL = process.env.VUE_APP_GATEWAY_API
  } else {
    const domain = document.domain
    baseURL = process.env.VUE_APP_BASE_API
    // for wellcome
    if (domain.includes(".rta-os.com")) {
      baseURL = process.env.VUE_APP_BASE_API + "/wellcome"
    }
    if (domain.includes("shop.yuu.hk")) {
      baseURL = process.env.VUE_APP_BASE_API + "/wellcome"
    }
    // for mpj
    // http://uatmpjweb.rta-os.com/
    if (domain.includes("mpjweb")) {
      baseURL = process.env.VUE_APP_BASE_API
    }
  }
  return baseURL
}

export function domainAdaptationFullURL() {
  const origin = window.location.origin
  let baseURL = origin
  const domain = document.domain
  // for wellcome
  if (domain.includes(".rta-os.com")) {
    baseURL = origin + "/wellcome"
  }
  if (domain.includes("shop.yuu.hk")) {
    baseURL = origin + "/wellcome"
  }
  // for mpj
  // http://uatmpjweb.rta-os.com/
  if (domain.includes("mpjweb")) {
    baseURL = origin
  }
  return baseURL
}

export function noStoreInfo($cookies) {
  return !$cookies.get("store") || !$cookies.get("latitude") || !$cookies.get("longitude")
}

export const appendUrlParams = (url, urlParams = {}) => {
  const [baseUrl, queryString] = url.split("?")
  const params = new URLSearchParams(queryString || "")

  Object.keys(urlParams).forEach(key => {
    params.append(key, urlParams[key])
  })

  const newQueryString = params.toString()
  return `${baseUrl}?${newQueryString}`
}
